module.exports = __webpack_public_path__ + "static/img/img_23.e570f1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/images/img_23.png
// module id = vx0Y
// module chunks = 2